(function ($) {
  if($('.section--menu__wrapper')){

    $(".section--menu__wrapper").nextAll('section').each(function(idx){
      $(this).attr('id', 'section-0'+parseInt(idx+1));
    });

    $('.sections-list .section-item').each(function(index){
      console.log('s: '+index);
      $(this).find('a').attr('href','#section-0' + parseInt(index+1));
    })

  }
})(jQuery);
